import React, { type FC } from 'react';

import { useSearchParams } from 'react-router';

import type { Register, RegisterDialogRequest } from '../../../types/helsenorge.helseregistre.internalapi.entities.entities';
import type { HNHelseregistreJS } from '../../../types/Resources';

import Panel from '@helsenorge/designsystem-react/components/Panel';
import PanelList from '@helsenorge/designsystem-react/components/PanelList';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

import { isSearchParamRegisterId } from '../../../utils/search-param-utils';
import { getRegisterNavn } from '../../../utils/string-utils';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { RegisterDetaljer } from '../register-detaljer';
import { fetchRegisterDialogTyper } from '../register-dialog-types';

export interface RegisterListeComponentProps {
  registerliste: Array<Register>;
  resources: HNHelseregistreJS;
}

const RegisterListeComponent: FC<RegisterListeComponentProps> = ({ registerliste, resources }) => {
  const dispatch = useAppDispatch();
  const { meldeFeilRegister } = useAppSelector(state => state.registermelding);
  const [searchParams] = useSearchParams();

  return (
    <PanelList>
      {registerliste.map(register => {
        const isRegisterEqualMeldeFeilRegister: boolean = !!meldeFeilRegister && meldeFeilRegister.registerId === register.registerId;
        const openFromStart: boolean =
          isSearchParamRegisterId(searchParams, register?.registerId ?? '') || isRegisterEqualMeldeFeilRegister;
        const ref: React.RefObject<HTMLHeadingElement | null> = React.createRef();
        const handleExpand = (): void => {
          if (register?.hasDialog && isAuthorized() && register?.herId && register?.registerId) {
            const arg: RegisterDialogRequest = {
              herId: register.herId,
              registerId: register.registerId,
            };
            dispatch(fetchRegisterDialogTyper(arg));
          }
        };
        return (
          <Panel key={register.registerId ?? register.navn} ref={ref} expanded={openFromStart} onExpand={handleExpand} testId="expand">
            <Panel.Title title={getRegisterNavn(register.navn, register.forkortelse)} />
            <Panel.A>{register.beskrivelseFormaal}</Panel.A>
            <Panel.ExpandedContent>
              <RegisterDetaljer
                parentRef={ref}
                register={register}
                resources={resources}
                onExpand={handleExpand}
                isOpenFromStart={openFromStart}
              />
            </Panel.ExpandedContent>
          </Panel>
        );
      })}
    </PanelList>
  );
};

export default RegisterListeComponent;
